<h2 class="webapp-title-secondary" >{{sectionInfo.title}}</h2> <!-- *ngIf="!userHasInssurance && !loading && false" -->
<div class="info-block rounded">
  <h2 class="webapp-title-secondary">{{sectionInfo.subtitle}}</h2>
    <div class="list"> <!-- *ngIf="!userHasInssurance && !loading" -->
      <ul> 
          <li *ngFor="let item of sectionInfo.array">
              <div class="item-content flex-row">
                  <div class="item-media icon-md dark margin-sides-1rem"><i class="fa-solid fa-circle-check"></i></div>
                  <div class="item-inner">
                      <div class="item-title">{{item.title}}</div>
                      <!-- <div class="item-after"><span class="badge color-black">Link</span></div> -->
                  </div>
              </div>
          </li>
      </ul>
    </div>
</div>